module.exports = __webpack_public_path__ + "img/ceti.f607f888.png";